import { Component, DestroyRef, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { CustomerService } from '../shared/services/customer.service';
import { ActivatedRoute, Router } from '@angular/router';
import {
  BrandingModerationAttributeEnum,
  CustomerModerationAttributeEnum,
} from '../shared/models/customer-changes-enum';
import { CustomMessageService } from '@admin/core/message.service';
import { MessageType } from '@admin/core/models/enum/message-type';
import { ApplicationMessageSource } from '@admin/core/models/application-message-source';
import { ApplicationMessage } from '@admin/core/models/application-message';
import { CustomerModerationViewModel } from '../shared/models/customer-moderation.model';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@admin/core/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-customers-moderation',
  templateUrl: './customers-moderation.component.html',
  styleUrls: ['./customers-moderation.component.less'],
  standalone: false,
})
export class CustomersModerationComponent {
  @ViewChild('originalDescription') originalDescription: ElementRef;
  @ViewChild('editedDescription') editedDescription: ElementRef;

  public customer: CustomerModerationViewModel;
  public customerId: number;

  ngAfterViewChecked() {
    if (this.originalDescription && this.editedDescription) {
      this.setEqualHeight();
    }
  }

  setEqualHeight() {
    const firstHeight = this.originalDescription.nativeElement.offsetHeight;
    const secondHeight = this.editedDescription.nativeElement.offsetHeight;

    const maxHeight = Math.max(firstHeight, secondHeight);

    this.renderer.setStyle(
      this.originalDescription.nativeElement,
      'height',
      `${maxHeight}px`
    );
    this.renderer.setStyle(
      this.editedDescription.nativeElement,
      'height',
      `${maxHeight}px`
    );
  }

  constructor(
    private customerService: CustomerService,
    private activatedRoute: ActivatedRoute,
    private translateService: TranslateService,
    private messageService: CustomMessageService,
    private router: Router,
    private renderer: Renderer2
  ) {}

  getCustomerData(customerId: number) {
    this.customerService
      .getModerationCustomer(customerId)
      .subscribe((payload: any) => {
        this.customer = payload.data;
      });
  }

  onApprove(customerModerationId) {
    if (!confirm(this.translateService.instant('message.AreYouSure'))) {
      return;
    }
    this.customerService
      .approveCustomerModeration(customerModerationId)
      .subscribe((d: any) => {
        if (d.success) {
          this.messageService.pushMessage(<ApplicationMessage>{
            type: MessageType.Success,
            sourceId: ApplicationMessageSource.global,
            summary: '',
            detail: this.translateService.instant('message.SaveMessage'),
          });
          this.router.navigate(['./customers/list']);
        } else if (!d.success) {
          this.messageService.pushMessage(<ApplicationMessage>{
            type: MessageType.Error,
            sourceId: ApplicationMessageSource.global,
            summary: '',
            detail: d.displayMessage,
          });
        }
      });
  }

  onReject(customerModerationId) {
    if (!confirm(this.translateService.instant('message.AreYouSure'))) {
      return;
    }
    this.customerService
      .rejectCustomerModeration(customerModerationId)
      .subscribe((d: any) => {
        if (d.success) {
          this.messageService.pushMessage(<ApplicationMessage>{
            type: MessageType.Success,
            sourceId: ApplicationMessageSource.global,
            summary: '',
            detail: this.translateService.instant('message.SaveMessage'),
          });
          this.router.navigate(['./customers/list']);
        } else if (!d.success) {
          this.messageService.pushMessage(<ApplicationMessage>{
            type: MessageType.Error,
            sourceId: ApplicationMessageSource.global,
            summary: '',
            detail: d.displayMessage,
          });
        }
      });
  }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.customerId = +params.get('id');
      this.getCustomerData(this.customerId);
    });
  }
}
